import { useEffect, useState } from 'react';

/**
 * Returns Date.now() refreshed every `intervalMs`, so durations (e.g. live call
 * time) tick smoothly between server snapshots instead of jumping.
 */
export function useTicker(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const h = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(h);
  }, [intervalMs]);

  return now;
}

/** Elapsed seconds since an ISO timestamp, recomputed against `now`. */
export function elapsedSec(startedAtIso: string | null | undefined, now: number): number {
  if (!startedAtIso) return 0;
  const t = Date.parse(startedAtIso);
  if (Number.isNaN(t)) return 0;
  return Math.max(0, Math.floor((now - t) / 1000));
}

/** Format seconds as m:ss (or h:mm:ss for long calls). */
export function fmtDuration(sec: number): string {
  const s = Math.max(0, Math.floor(sec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return h > 0 ? `${h}:${pad(m)}:${pad(r)}` : `${m}:${pad(r)}`;
}
